import { storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc';
import { colorStyle } from '@/lib/helpers';
import CardsTimelineTrack from '@/components/CardsTimelineTrack';

const colClasses = {
  '2': 'grid-cols-1 sm:grid-cols-2',
  '3': 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3',
  '4': 'grid-cols-1 sm:grid-cols-2 md:grid-cols-4',
};

// The Gap option's value as a CSS length, for the timeline's line to span it.
function gapLength(gap = 'gap-[2rem]') {
  if (gap === 'gap-0') return '0px';
  if (gap === 'gap-px') return '1px';
  return gap.match(/^gap-\[(.+)\]$/)?.[1] || '2rem';
}

const Cards = ({ blok }) => {
  const cols = colClasses[blok.columns] || colClasses['3'];
  const cards = blok.reverse_order ? [...(blok.cards || [])].reverse() : blok.cards;

  return (
    <section {...storyblokEditable(blok)} className="px-4 py-8 sm:p-12 lg:p-16" style={colorStyle(blok)}>
      <div className="max-w-container mx-auto">
      {blok.title && (
        <h2 className={`text-32 sm:text-36 md:text-48 font-extrabold text-center ${blok.description ? 'mb-4' : 'mb-[3.5rem]'}`}>
          {blok.title}
        </h2>
      )}
      {blok.description && (
        <p className="text-16 sm:text-18 text-center max-w-[800px] mx-auto mb-10">
          {blok.description}
        </p>
      )}
      {blok.layout === 'timeline' ? (
        <CardsTimelineTrack gap={gapLength(blok.gap)}>
          {cards?.map((card) => (
            <div className="cards-timeline-item" key={card._uid}>
              <StoryblokServerComponent blok={card} />
            </div>
          ))}
        </CardsTimelineTrack>
      ) : (
        <div className={`grid ${cols} ${blok.gap || 'gap-[2rem]'}`}>
          {cards?.map((card) => (
            <StoryblokServerComponent blok={card} key={card._uid} />
          ))}
        </div>
      )}
      </div>
    </section>
  );
};

export default Cards;
